import { render, staticRenderFns } from "./Toppers.vue?vue&type=template&id=280cec36&"
import script from "./Toppers.vue?vue&type=script&lang=js&"
export * from "./Toppers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports